import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './VisitPage.css'
import {
    getActiveVenue,
    getActiveVenueId,
    getAgentList,
    getLeadManageParentPath,
    getLeadManageStaticContent, getPartnerAccount,
    getUserAgent
} from '../../../App/AppReducer';
import { addVisit, fetchLeadDetails, fetchVisitList, removeVisit, showFullViewTabVisibleState, updateVisit } from "../../LeadManageActions";
import {
    getFullViewTabVisiblestate,
    getLeadDetails,
    getLeadLogId,
    getSelectedLeadId,
    getVisitCount,
    getVisitPageNum,
    getVisitPageSize,
    getVisits
} from '../../LeadManageReducer';
import VmSvgImage from '../../../../components/Icons/VmSvgImage';
import NavBar from "../../components/NavBar";
import Breadcrumb from '../../components/Beadcrumb';
import { withRoute } from 'util/withRoute';
import { Button } from "react-bootstrap";
import { DatePicker, Drawer, Modal, Radio, Table } from "antd";
import MobileNavigationBar from "../../components/MobileNavigationBar";
import dayjs from "dayjs";
import { userNotify } from "../../../../components/Toasts/ToastAdd";
import _ from "lodash";
import { fetchAgentList } from "../../../App/AppActions";
import { Helmet } from "react-helmet";
import SwitchControl from "../../../../components/PermissionLocks/SwitchControl";
import moment from 'moment';
import { current } from '@reduxjs/toolkit';

class VisitPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isUpdateFormVisible: false,
            updateVisit: {},
            isAddVisitDrawerOpen: false,
            isEditVisitDrawerOpen: false,
            isDeletingVisit: false,
            visitDate: '',
            isVisitCancelled: false,
            isVisitCompleted: false,
            isConfirmedByUser: false,
            isConfirmedByVenue: false,
            visits: [],
            activeVisit: {}
        };
    }

    visitColumns = [
        {
            title: 'Visit Date',
            dataIndex: 'visit_date',
            key: 'visit_date',
            render: (value) => (
            <div className={'dateColumn'}>
                {value ? (
                <>
                    <span style={{ fontWeight: '700', color: '#1a1a2e', fontSize: '14px' }}>
                    {dayjs(value).format('DD MMM YYYY')}
                    </span>
                    <span style={{ color: '#9aa3b8', fontSize: '12px', marginTop: '2px' }}>
                    {dayjs(value).format('hh:mm a')}
                    </span>
                </>
                ) : '--'}
            </div>
),
        },
        {
            title: 'User',
            dataIndex: 'isConfirmedByUser',
            key: 'isConfirmedByUser',
            render: (_, record) => <div className={'tableCellCenter'}><SwitchControl
                shouldHavePermissions={['leads:edit']}
                userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                yes={<Button onClick={() => this.setState({
                    isConfirmedByUser: !record.isConfirmedByUser,
                    activeVisit: record
                }, () => this.handleTableDataChange('userConfirmationChange'))}
                    className={`btn btn-sm btn-white ${record.isConfirmedByUser ? 'pill-yes' : 'pill-no'}`}>{record.isConfirmedByUser ? 'Yes' : 'No'}</Button>}
                no={<Button disabled={true} onClick={() => this.setState({
                    isConfirmedByUser: !record.isConfirmedByUser,
                    activeVisit: record
                }, () => this.handleTableDataChange('userConfirmationChange'))}
                    className={`btn btn-sm btn-white ${record.isConfirmedByUser ? 'pill-yes' : 'pill-no'}`}>{record.isConfirmedByUser ? 'Yes' : 'No'}</Button>} />
            </div>,
            align: 'center'
        },
        {
            title: 'Venue',
            dataIndex: 'isConfirmedByVenue',
            key: 'isConfirmedByVenue',
            render: (_, record) => <div className={'tableCellCenter'}><SwitchControl
                shouldHavePermissions={['leads:edit']}
                userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                yes={<Button onClick={() => this.setState({
                    isConfirmedByVenue: !record.isConfirmedByVenue,
                    activeVisit: record
                }, () => this.handleTableDataChange('venueConfirmationChange'))}
                    className={`btn btn-sm btn-white ${record.isConfirmedByVenue ? 'pill-yes' : 'pill-no'}`}>{record.isConfirmedByVenue ? 'Yes' : 'No'}</Button>}
                no={<Button disabled={true} onClick={() => this.setState({
                    isConfirmedByVenue: !record.isConfirmedByVenue,
                    activeVisit: record
                }, () => this.handleTableDataChange('venueConfirmationChange'))}
                    className={`btn btn-sm btn-white ${record.isConfirmedByVenue ? 'pill-yes' : 'pill-no'}`}>{record.isConfirmedByVenue ? 'Yes' : 'No'}</Button>} />
            </div>,
            align: 'center'
        },
        {
            title: 'Agent',
            dataIndex: 'agent_name',
            key: 'agent_name',
            render: (text) => <span>{text}</span>
        },
        {
            title: 'Cancelled',
            dataIndex: 'isVisitCancelled',
            key: 'isVisitCancelled',
            render: (_, record) => <div className={'tableCellCenter'}><SwitchControl
                shouldHavePermissions={['leads:edit']}
                userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                yes={<Button onClick={() => this.setState({
                    isVisitCancelled: !record.isVisitCancelled,
                    activeVisit: record
                }, () => this.handleTableDataChange('isCancelled'))}
                    className={`btn btn-sm btn-white ${record.isVisitCancelled ? 'pill-yes' : 'pill-no'}`}>{record.isVisitCancelled ? 'Yes' : 'No'}</Button>}
                no={<Button disabled={true} onClick={() => this.setState({
                    isVisitCancelled: !record.isVisitCancelled,
                    activeVisit: record
                }, () => this.handleTableDataChange('isCancelled'))}
                    className={`btn btn-sm btn-white ${record.isVisitCancelled ? 'pill-yes' : 'pill-no'}`}>{record.isVisitCancelled ? 'Yes' : 'No'}</Button>} /></div>,
            align: 'center'
        },

        {
            title: 'Done',
            dataIndex: 'isVisitCompleted',
            key: 'isVisitCompleted',
            render: (_, record) => <div className={'tableCellCenter'}><SwitchControl
                shouldHavePermissions={['leads:edit']}
                userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                yes={<Button onClick={() => this.setState({
                    isVisitCompleted: !record.isVisitCompleted,
                    activeVisit: record
                }, () => this.handleTableDataChange('isVisitDone'))}
                    className={`btn btn-sm btn-white ${record.isVisitCompleted ? 'pill-yes' : 'pill-no'}`}>{record.isVisitCompleted ? 'Yes' : 'No'}</Button>}
                no={<Button disabled={true} onClick={() => this.setState({
                    isVisitCompleted: !record.isVisitCompleted,
                    activeVisit: record
                }, () => this.handleTableDataChange('isVisitDone'))}
                    className={`btn btn-sm btn-white ${record.isVisitCompleted ? 'pill-yes' : 'pill-no'}`}>{record.isVisitCompleted ? 'Yes' : 'No'}</Button>} /></div>,
            align: 'center'
        },
        {
            title: 'Action',
            dataIndex: 'remove_visit',
            key: 'remove_visit',
            render: (_, record) => <div className={'tableCellCenter'}>
                <SwitchControl
                    shouldHavePermissions={['leads:edit']}
                    userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                    yes={<Button onClick={() => {
                        this.setState({
                            isDeletingVisit: true,
                            activeVisit: record ? record : {},
                        })
                    }} className="btn btn-sm btn-white"><i
                        className="fa fa-times"></i></Button>}
                    no={<Button disabled={true} onClick={() => {
                        this.setState({
                            isDeletingVisit: true,
                            activeVisit: record ? record : {},
                        })
                    }} className="btn btn-sm btn-white"><i
                        className="fa fa-times"></i></Button>}
                />
                <SwitchControl
                    shouldHavePermissions={['leads:edit']}
                    userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                    yes={<Button onClick={() => {
                        this.setState({
                            isEditVisitDrawerOpen: true,
                            activeVisit: record ? record : {},
                            visitDate: record.visit_date ? record.visit_date : '',
                            isConfirmedByUser: record.isConfirmedByUser,
                            isConfirmedByVenue: record.isConfirmedByVenue,
                            isVisitCompleted: record.isVisitCompleted
                        })
                    }} className="btn btn-sm btn-white"><i className="fa fa-pencil"></i></Button>}
                    no={<Button disabled={true} onClick={() => {
                        this.setState({
                            isEditVisitDrawerOpen: true,
                            activeVisit: record ? record : {},
                            visitDate: record.visit_date ? record.visit_date : '',
                            isConfirmedByUser: record.isConfirmedByUser,
                            isConfirmedByVenue: record.isConfirmedByVenue,
                            isVisitCompleted: record.isVisitCompleted
                        })
                    }} className="btn btn-sm btn-white"><i className="fa fa-pencil"></i></Button>}
                />
            </div>,
            align: 'center'
        },

    ]

    componentDidMount() {
        let filters = {};
        filters.pageNum = this.props.pageNum;
        filters.pageSize = this.props.pageSize;
        let leadId = this.props.leadid ? this.props.leadid : this.props.params.leadid ? this.props.params.leadid : '';

        this.props.dispatch(fetchAgentList())

        if (leadId) {
            this.props.dispatch(fetchLeadDetails(leadId));
        }

        let eventId = this.props?.lead?.event
        let venueId = this.props?.venueId

        if (eventId && venueId) {
            this.props.dispatch(fetchVisitList(eventId, venueId, filters));
            this.setState({
                visits: this.props.visits,
            })
        }
        if (this.props.visits && this.props.agentList) {
            this.createVisitTableData(this.props.agentList, this.props.visits)
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let leadId = this.props.params.leadid ? this.props.params.leadid : this.props.leadid ? this.props.leadid : '';
        let eventId = this.props?.lead?.event
        let venueId = this.props?.venueId
        let filters = {};
        filters.pageNum = this.props.pageNum;
        filters.pageSize = this.props.pageSize;
        if (prevProps.leadId && leadId && (prevProps.leadId !== leadId)) {
            this.props.dispatch(fetchLeadDetails(leadId));
        }


        if (eventId && venueId && ((prevProps.venueId !== venueId) || (prevProps.lead.event !== eventId))) {
            this.props.dispatch(fetchVisitList(eventId, venueId));
            this.setState({
                visits: this.props.visits
            })
        }

        if (!_.isEqual(this.props.visits, prevProps.visits)) {
            this.createVisitTableData(this.props.agentList, this.props.visits)
        }
    }

    handleTableDataChange = (type) => {
        let visit = { ...this.state.activeVisit }
        switch (type) {
            case 'userConfirmationChange':
                visit.isConfirmedByUser = this.state.isConfirmedByUser
                break
            case 'venueConfirmationChange':
                visit.isConfirmedByVenue = this.state.isConfirmedByVenue
                break
            case 'isCancelled':
                visit.isVisitCancelled = this.state.isVisitCancelled
                break
            case 'isVisitDone':
                visit.isVisitCompleted = this.state.isVisitCompleted
            default:
                break
        }
        this.props.dispatch(updateVisit(visit._id, visit, this.props.agent, this.props.logId))
    }

    handleVisitDateChange = (date) => {
        this.setState({
            visitDate: date
        })
    }

    handleCloseOverlay = () => {
        this.setState({
            isUpdateFormVisible: false,
            updateVisit: {}
        });
    };

    handleOpenOverlay = (visit) => {
        this.setState({
            isUpdateFormVisible: true,
            updateVisit: visit,
        });
    };

    handleAddVisitDrawer = () => {
        this.setState({
            isAddVisitDrawerOpen: true
        })
    }

    closeDrawerForm = () => {
        this.setState({
            isAddVisitDrawerOpen: false,
            isEditVisitDrawerOpen: false,
            visitDate: '',
            isConfirmedByUser: false,
            isConfirmedByVenue: false,
            isVisitCompleted: false
        })
    }

    handleSaveVisit = () => {
        let visit = {}
        if (!_.isEmpty(this.state.visitDate)) {

            visit.visit_date = this.state?.visitDate?.toISOString();
            visit.agentId = this.props.lead.admin_id
            visit.venueId = this.props.activeVenue._id
            visit.eventId = this.props.lead.event
            visit.venue_name = this.props.activeVenue.name
            visit.isConfirmedByUser = true
            visit.isConfirmedByVenue = true
            visit.isCreatedByVenue = true
            visit.lead_source = "partner-crm";
            visit.ref_id = this.props.leadId
            visit.ref_name = "venueBundle"
            visit.isCreatedByAdmin = false
            this.props.dispatch(addVisit(this.props.lead.event, this.props.activeVenue._id, visit))
            this.setState({
                visitDate: '',
                isConfirmedByUser: false,
                isConfirmedByVenue: false,
                isVisitCompleted: false,
                isVisitCancelled: false,
                activeVisit: {},
                isAddVisitDrawerOpen: false,
            })
        } else {
            userNotify('Please select a visit date', 'warning')
        }
    }

    handleAddCustomerVisit = () => {
        this.props.dispatch()
    }

    createVisitTableData = (agentList, visits) => {
        try {
            let agentMap = {}
            agentList.forEach((agent) => {
                agentMap[agent._id] = agent
            })
            if (visits && visits.length > 0) {
                let newVisits = visits.map(visit => {
                    return {
                        ...visit,
                        key: visit._id,
                        agent_name: visit?.agentId && agentMap[visit?.agentId] && agentMap[visit.agentId]?.name ? agentMap[visit.agentId]?.name : '--'
                    }
                })
                this.setState({
                    visits: newVisits
                })
            }
        } catch (e) {
            console.log(e)
        }
    }

    handleRemoveVisit = () => {
        if (this.state.activeVisit) {
            let visit = { ...this.state.activeVisit }
            this.props.dispatch(removeVisit(visit.eventId, visit.venueId, visit._id, visit))
        }
        this.setState({
            isDeletingVisit: false,
            activeVisit: {}
        })
    }

    handleUpdateVisit = () => {
        if (this.state.activeVisit) {
            let visit = { ...this.state.activeVisit }
            visit.visit_date = this.state.visitDate ? this.state.visitDate.toISOString() : ''
            visit.isConfirmedByVenue = this.state.isConfirmedByVenue
            visit.isCreatedByVenue = true
            visit.ref_id = this.props.leadId
            visit.ref_name = "venueBundle"
            visit.isVisitCompleted = this.state.isVisitCompleted
            visit.isVisitCancelled = this.state.isVisitCancelled
            this.props.dispatch(updateVisit(visit._id, visit, this.props.agent, this.props.logId))
        }
        this.setState({
            isEditVisitDrawerOpen: false,
            visitDate: '',
            isConfirmedByUser: false,
            isConfirmedByVenue: false,
            isVisitCompleted: false,
            isVisitCancelled: false,
            activeVisit: {}
        })
    }

    handleShowFullView = (val) => {
        this.props.dispatch(showFullViewTabVisibleState(val));
    }


    render() {
        let segment, drawerContent, staticContent = this.props.staticContent;
        let breakpoint = 800;

        drawerContent = this.state.isAddVisitDrawerOpen || this.state.isEditVisitDrawerOpen ? (
            <div className="visit-drawer-wrapper">
                <div className="visit-form-field">
                    <label className="visit-field-label">{staticContent.VISIT_PAGE_ADD_VISIT_SELECT_LABEL || 'Select a visit date'}</label>
                    <DatePicker className="visit-datepicker"
                                disabledDate={(current) => {const today = new Date();
                                    today.setHours(0,0,0,0);
                                    return current && current.valueOf() < today.valueOf();}}
                                showTime={true}
                                format={'DD MMM YYYY hh:mm a'}
                                value={this.state.visitDate ? dayjs(this.state.visitDate) : ''}
                                onChange={(date) => date && this.handleVisitDateChange(date)}
                    />
                </div>
                <div className="visit-form-field">
                    <label className="visit-field-label">{staticContent.VISIT_PAGE_ADD_VISIT_CUSTOMER_CONFIRM_LABEL ||'Confirmed by Customer' }</label>
                    <Radio.Group value={this.state.isConfirmedByUser}
                        onChange={e => this.setState({ isConfirmedByUser: e.target.value })}
                        className="visit-radio-group">
                        <Radio value={false}>NO</Radio>
                        <Radio value={true}>YES</Radio>
                    </Radio.Group>
                </div>
                <div className="visit-form-field">
                    <label className="visit-field-label">{staticContent.VISIT_PAGE_ADD_VISIT_VENUE_CONFIRM_LABEL || 'Confirmed by Venue'}</label>
                    <Radio.Group value={this.state.isConfirmedByVenue}
                        onChange={e => this.setState({ isConfirmedByVenue: e.target.value })}
                        className="visit-radio-group">
                        <Radio value={false}>NO</Radio>
                        <Radio value={true}>YES</Radio>
                    </Radio.Group>
                </div>
            </div>
        ) : null;

        segment = <div className="col-sm-12 segmentContainer">

            {/* Visit listtableRow */}
            <div className={'segment'}>
                <h5>Visits</h5>
                <div>
                    <SwitchControl
                        shouldHavePermissions={['leads:edit']}
                        userPermissions={this.props.partneraccount.permissions ? this.props.partneraccount.permissions : []}
                        yes={<button onClick={this.handleAddVisitDrawer}
                            className="btn-primary-custom">+ {staticContent.VISIT_PAGE_ADD_VISIT ? staticContent.VISIT_PAGE_ADD_VISIT : 'Add Visit'}</button>}
                        no={<button disabled={true} onClick={this.handleAddVisitDrawer}
                            className="btn-primary-custom">+ {staticContent.VISIT_PAGE_ADD_VISIT ? staticContent.VISIT_PAGE_ADD_VISIT : 'Add Visit'}</button>}
                    />
                </div>
            </div>

            <div className={'tableContainer'}>
  {this.props.visits && this.props.visits.length > 0 ? (
    <>
      {/* WEB TABLE — hidden on mobile via CSS */}
      <div className="visitWebTable">
        <Table size={'middle'} tableLayout={'auto'} bordered={false} pagination={false}
          columns={this.visitColumns} dataSource={this.state.visits ? this.state.visits : []} />
      </div>

      {/* MOBILE CARDS — hidden on web via CSS */}
      <div className="visitMobileCard">
        {(this.state.visits || []).map((visit) => (
          <div key={visit._id} className="visitMobileCardItem">
            <div className="visitMobileDateRow">
            <span className="visitMobileDate">
                {visit.visit_date ? dayjs(visit.visit_date).format('DD MMM YYYY') : '--'}
            </span>
            <span className="visitMobileTime">
                {visit.visit_date ? dayjs(visit.visit_date).format('hh:mm a') : ''}
            </span>
            </div>
            <div className="visitMobileAgent">Agent: {visit.agent_name || '--'}</div>
            <div className="visitMobileStatusRow">
              <span className="visitMobileStatusLabel">User:</span>
              <button className={`visitMobilePill ${visit.isConfirmedByUser ? 'visitMobilePillYes' : 'visitMobilePillNo'}`}
                onClick={() => this.setState({ isConfirmedByUser: !visit.isConfirmedByUser, activeVisit: visit }, () => this.handleTableDataChange('userConfirmationChange'))}>
                {visit.isConfirmedByUser ? 'Yes' : 'No'}
              </button>
              <span className="visitMobileStatusLabel">Venue:</span>
              <button className={`visitMobilePill ${visit.isConfirmedByVenue ? 'visitMobilePillYes' : 'visitMobilePillNo'}`}
                onClick={() => this.setState({ isConfirmedByVenue: !visit.isConfirmedByVenue, activeVisit: visit }, () => this.handleTableDataChange('venueConfirmationChange'))}>
                {visit.isConfirmedByVenue ? 'Yes' : 'No'}
              </button>
              <span className="visitMobileStatusLabel">Cancelled:</span>
              <button className={`visitMobilePill ${visit.isVisitCancelled ? 'visitMobilePillYes' : 'visitMobilePillNo'}`}
                onClick={() => this.setState({ isVisitCancelled: !visit.isVisitCancelled, activeVisit: visit }, () => this.handleTableDataChange('isCancelled'))}>
                {visit.isVisitCancelled ? 'Yes' : 'No'}
              </button>
              <span className="visitMobileStatusLabel">Done:</span>
              <button className={`visitMobilePill ${visit.isVisitCompleted ? 'visitMobilePillYes' : 'visitMobilePillNo'}`}
                onClick={() => this.setState({ isVisitCompleted: !visit.isVisitCompleted, activeVisit: visit }, () => this.handleTableDataChange('isVisitDone'))}>
                {visit.isVisitCompleted ? 'Yes' : 'No'}
              </button>
            </div>
            <div className="visitMobileActions">
              <button className="visitMobileActionBtn" onClick={() => this.setState({ isDeletingVisit: true, activeVisit: visit })}>
                <i className="fa fa-trash" />
              </button>
              <button className="visitMobileActionBtn" onClick={() => this.setState({ isEditVisitDrawerOpen: true, activeVisit: visit, visitDate: visit.visit_date || '', isConfirmedByUser: visit.isConfirmedByUser, isConfirmedByVenue: visit.isConfirmedByVenue, isVisitCompleted: visit.isVisitCompleted })}>
                <i className="fa fa-pencil" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  ) : (
    <div className='empty-list-illustrations emptyVisitImage'>
      <VmSvgImage targetClass="" iconName="vm-location-illustration" />
      <div className={'emptyVisitText'}>No Past Visit</div>
    </div>
  )}
</div>
        </div>;
        return (
            <div className="row lead-manage-page"
                style={{ padding: this.props.windowWidth > breakpoint ? '10px 30px' : '10px', marginTop: '0px' }}>
                <Helmet>
                    <title>Visit List</title>
                </Helmet>
                <Modal onCancel={() => this.setState({ isDeletingVisit: false, activeVisit: {} })}
                    onOk={() => this.handleRemoveVisit()} open={this.state.isDeletingVisit}>
                    <p>Are you sure you want to remove the visit</p>
                </Modal>
               {/* ADD/Edit Visit modal */}
                <Drawer
                    width={this.props.windowWidth > 768 ? 420 : '100%'}
                    height="50%"
                    placement={this.props.windowWidth > 768 ? 'right' : 'bottom'}
                    open={this.state.isAddVisitDrawerOpen || this.state.isEditVisitDrawerOpen}
                    onClose={this.closeDrawerForm}
                    className={this.props.windowWidth <= 768 ? 'mobile-override-drawer' : 'web-visit-drawer'}
                    title={null}
                    closable={false}
                    bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%', backgroundColor: '#ffffff' }}
                >
                    <div className="custom-drawer-header">
                        <span className="custom-drawer-title">
                            {this.state.isAddVisitDrawerOpen ? (staticContent.VISIT_PAGE_ADD_VISIT || 'Add Visit') : (staticContent.VISIT_PAGE_EDIT_VISIT || 'Edit Visit')}
                        </span>
                        <button className="custom-drawer-close-btn" onClick={this.closeDrawerForm}>✕</button>
                    </div>
                    <div style={{ flex: 1, overflowY: 'auto' }}>
                        {drawerContent}
                    </div>
                    <div className="custom-drawer-footer">
                        <button className="btn-secondary-custom" onClick={this.closeDrawerForm}>Cancel</button>
                        <button 
                            className="btn-primary-custom" 
                            onClick={this.state.isAddVisitDrawerOpen ? this.handleSaveVisit : this.handleUpdateVisit}
                        >
                            Save
                        </button>
                    </div>
                </Drawer>
                {/* <Breadcrumb
                    windowWidth={this.props.windowWidth}
                    breakpoint={breakpoint}
                    isLeadManageFromLeadList={this.props.isLeadManageFromLeadList}
                    contact_name={this.props.lead.contact_name}
                /> */}

                {/* {this.props.isFullViewTabvisible && (
            <div>
                {this.props.windowWidth > breakpoint ? <NavBar
                    url={`/event/${this.props.leadid || this.props.params.leadid || this.props?.leadId}/visit`}
                    leadid={this.props.leadid || this.props.params.leadid}
                    staticContent={staticContent}
                /> : <MobileNavigationBar
                    url={`/event/${this.props.leadid || this.props.params.leadid || this.props?.leadId}/visit`}
                    leadid={this.props.leadid || this.props.params.leadid}
                    staticContent={staticContent}
                />}
                </div> )} */}
                <div
                    style={{ border: this.props.windowWidth < breakpoint ? 'none' : '' }}>
                    {segment}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        agentList: getAgentList(state),
        leadid: props.params?.leadid,
        leadId: getSelectedLeadId(state),
        currentUrl: props.location?.pathname,
        staticContent: getLeadManageStaticContent(state),
        pageSize: getVisitPageSize(state),
        pageNum: getVisitPageNum(state),
        count: getVisitCount(state),
        visits: getVisits(state),
        lead: getLeadDetails(state),
        isLeadManageFromLeadList: getLeadManageParentPath(state),
        activeVenue: getActiveVenue(state),
        logId: getLeadLogId(state),
        agent: getUserAgent(state),
        venueId: getActiveVenueId(state),
        partneraccount: getPartnerAccount(state),
        isFullViewTabvisible: getFullViewTabVisiblestate(state)

    };
}


VisitPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    router: PropTypes.object,
};


export default connect(mapStateToProps)(withRoute(VisitPage));
